import React from "react";
import "./postCardVertical.scss";
import parse from "html-react-parser";
import { Link } from "gatsby";
import Image from "gatsby-image";
import FallBackImg from "../FallBackImg/fallBackImg";

const PostCardVertical = ({ post, customClass, showDescription = false,}) => {
  const featuredImage = post.featuredImage
    ? {
      fluid:
          post.featuredImage?.node?.localFile
            ?.childImageSharp?.fluid,
      alt: post.featuredImage?.node?.alt || "",
    }
    : null;

  return (
    <article itemScope itemType="http://schema.org/Article">
      <div
        className={`post-card-vertical ${
          customClass ? customClass : ""
        }`}
      >
        <Link to={post.uri} itemProp="url">
          {featuredImage ? (
            <Image
              fluid={featuredImage.fluid}
              alt={featuredImage.alt}
              style={{width: "100%"}}
            />
          ) : (
            <div className="gatsby-image-wrapper">
              <FallBackImg />
            </div>
          )}

          <h2 className="title">
            <Link to={post.uri} itemProp="url">
              <span itemProp="headline">
                {parse(post.title || " ")}
              </span>
            </Link>
          </h2>
          {showDescription && (
            <section
              itemProp="description"
              className="description"
            >
              <Link to={post.uri} itemProp="url">
                {parse(post.excerpt || " ")}
              </Link>
            </section>
          )}
        </Link>
      </div>
      <div className="info-wrap">
        <div className="info categories-wrap">
          {post.categories?.nodes.map((item, index) => (
            <Link to={item.uri} itemProp="url" key={index}>
              <div className="category" key={index}>
                {item.name}
              </div>
            </Link>
          ))}
        </div>
        <div className="info date-wrap">
          <div className="date">{post.date}</div>
        </div>
        <div className="info read-time-wrap">{post.seo?.readingTime} min read</div>
      </div>
    </article>
  );
};

export default PostCardVertical;
